import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78266758"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "middle"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" GAME OVER ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "middle"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" YOU'VE WON ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "header" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "MONKEY SEE", -1))
const _hoisted_11 = {
  key: 0,
  class: "middle"
}
const _hoisted_12 = { class: "right" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal", _ctx.status])
    }, [
      (_ctx.status === 'lost')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickBoard()))
            }, "CLICK TO PLAY AGAIN")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createTextVNode(" SCORE = " + _toDisplayString(_ctx.score) + " ", 1),
            _hoisted_7,
            _createTextVNode(" HIGH SCORE = " + _toDisplayString(_ctx.highScore) + " ", 1),
            _hoisted_8,
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickBoard()))
            }, "CLICK TO PLAY AGAIN")
          ]))
    ], 2),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      (_ctx.status === 'playing')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "CLICK " + _toDisplayString(_ctx.nextNumber), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.timeFmt), 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["board", _ctx.status])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          key: row,
          class: "row"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cols, (col) => {
            return (_openBlock(), _createElementBlock("div", {
              key: col,
              class: _normalizeClass(["cell", _ctx.cellClass(row - 1, col - 1)]),
              onClick: ($event: any) => (_ctx.clickCell(row - 1, col - 1))
            }, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.cells[row - 1][col - 1]), 1)
            ], 10, _hoisted_13))
          }), 128))
        ]))
      }), 128))
    ], 2)
  ], 64))
}